/**
 * Shows a customer's loyalty state
 */
import React from 'react';
import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';
import './style.less';

import PunchCardCompact from '../PunchCardCompact';

const { Customer, Order } = Mobi2Go;

export default forwardRefWithTranslation('order.loyalty')(
    class Shift8 extends React.Component {
        state = {
            points: 0,
            updated_at: null,
            is_customer_logged_in: null,
        };

        refresh_timeout;

        poll_timeout;

        poll_interval;

        componentDidMount = () => {
            this.updateState();
            Customer.bind({
                logIn: this.updateState,
                logOut: this.updateState,
                updateLoyalty: this.updateState,
            });

            Order.bind('updateProgressPhase', phase => {
                if (phase === 'confirmed' && this.isShift8Enabled()) {
                    this.pollForState();
                }
            });
        };

        componentWillUnmount = () => {
            Customer.unbind({
                logIn: this.updateState,
                logOut: this.updateState,
                updateLoyalty: this.updateState,
            });
            this.clearRefreshStateTimeout();
        };

        updateState = () => {
            const loyalty = Customer.getLoyalty('Shift8Points');

            this.setState({
                is_customer_logged_in: Customer.isLoggedIn(),
                points: loyalty ? loyalty.state.points : 0,
                updated_at: loyalty ? loyalty.state.updated_at : null,
                loyalty,
            });

            if (loyalty) {
                this.queueRefreshState();
            } else {
                this.clearRefreshStateTimeout();
            }
        };

        queueRefreshState = (timeout = 60000) => {
            this.clearRefreshStateTimeout();
            this.refresh_timeout = setTimeout(this.refreshState, timeout);
        };

        isShift8Enabled = () => !!Customer.getLoyalty('Shift8Points');

        clearRefreshStateTimeout = () => {
            clearTimeout(this.refresh_timeout);
            this.refresh_timeout = null;
        };

        refreshState = () => {
            if (!Customer.isLoggedIn()) {
                return;
            }

            Mobi2Go.app.serverRequest({
                api_version: 1,
                endpoint: [
                    'customers',
                    Customer.getEmail(),
                    'loyalty',
                    'Shift8Points',
                ],
                type: 'GET',
                data: { refresh: true },
                success: () => {
                    Customer.refresh();
                },
                error: () => {
                    this.queueRefreshState();
                },
            });
        };

        // Poll for state update every 5 seconds for 3 minutes
        pollForState = () => {
            this.stopPollingForState();
            this.poll_interval = setInterval(this.refreshState, 5000);
            this.poll_timeout = setTimeout(
                this.stopPollingForState,
                1000 * 60 * 3
            );
        };

        stopPollingForState = () => {
            clearInterval(this.poll_interval);
            clearTimeout(this.poll_timeout);
        };

        render = () => {
            if (!Customer.isLoggedIn() || !this.isShift8Enabled()) {
                return null;
            }
            const { t } = this.props;
            const { points, loyalty } = this.state;

            const className = name =>
                `m2g-customer-loyalty-shift8-points-balance${name || ''}`;

            return (
                <>
                    <div className={className()}>
                        <div className={className('-label')}>
                            {t('shift8_points')}
                        </div>
                        <div className={className('-value')}>{points}</div>
                    </div>
                    {loyalty?.program?.settings?.stamp_card_active && (
                        <PunchCardCompact
                            title={loyalty.program.title}
                            description={loyalty.program.description}
                            terms_and_conditions={
                                loyalty.program.terms_and_conditions
                            }
                            num_punches_needed={
                                loyalty?.program?.settings.num_punches_needed
                            }
                            punches={loyalty?.state?.product_points}
                        />
                    )}
                </>
            );
        };
    }
);
